import React from 'react';
import { CtaButton } from './CtaButton';
import { authorQuestions, authorQuotes, images } from '../data/content';
export function Author() {
  return <section className="bg-brand-950 py-16 text-white sm:py-24" aria-labelledby="author-title" data-id="element-18" data-mp="ojw8hk0b9sm5">
      <div className="mx-auto grid max-w-5xl gap-10 px-4 sm:px-6 md:grid-cols-[2fr_3fr] md:gap-14" data-id="element-19" data-mp="9qso74vc50rq">
        <div className="md:sticky md:top-8 md:self-start" data-id="element-20" data-mp="epvvkvysfj2v">
          <img src={images.author} alt="Dr. Michael Carter" className="aspect-[4/5] w-full rounded-3xl object-cover object-top shadow-2xl" data-id="element-21" data-mp="12im5z0r1lub1" />
          <p className="mt-4 text-center font-serif text-xl font-bold" data-id="element-22" data-mp="sk6c4q0ms6xu">Dr. Michael Carter</p>
          <p className="text-center text-sm text-brand-300" data-id="element-23" data-mp="xhyc87bfizd4">Creator of the CBCT Decision Map™</p>
        </div>

        <div data-id="element-24" data-mp="3d9cfa42a20ky">
          <p className="text-sm font-bold uppercase tracking-wider text-brand-300" data-id="element-25" data-mp="3d8ueqv8l1078">About the author</p>
          <h2 id="author-title" className="mt-2 font-serif text-[34px] font-extrabold leading-tight sm:text-5xl" data-id="element-26" data-mp="3i9i65i0q3j1z">
            I’m Dr. Michael Carter
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-brand-100" data-id="element-27" data-mp="1p00jd1izyv92">
            <p data-id="element-28" data-mp="22z0acftzfm8e">
              For years, I’ve seen dentists face the same problem when they begin incorporating CBCT into their
              implant-planning workflow.
            </p>
            <p data-id="element-29" data-mp="1y2i57euqplvj">
              The problem usually isn’t access to information. There is plenty of information available.{' '}
              <strong className="text-white" data-id="element-30" data-mp="27yv18jdrcbtg">The problem is knowing:</strong>
            </p>
          </div>
          <ul className="mt-4 space-y-2 border-l-2 border-brand-500 pl-5" data-id="element-31" data-mp="2lpztv1ipk3ua">
            {authorQuestions.map(q => <li key={q} className="font-serif text-lg italic text-white" data-id="element-32" data-mp="2hpftzq6r2m4g">
                {q}
              </li>)}
          </ul>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-brand-100" data-id="element-33" data-mp="2vll3nlu0q8el">
            <p data-id="element-34" data-mp="2qmq9xouiizfp">
              When you’re looking at a CBCT with dozens of slices and multiple anatomical structures, having more
              information doesn’t necessarily make the process easier.
            </p>
            <p className="text-lg font-semibold text-white" data-id="element-35" data-mp="1xc3bh96to2yl">
              What makes it easier is having a system for organizing the information.
            </p>
            <p data-id="element-36" data-mp="224ebsd5h5qro">
              That’s why I created the CBCT Decision Map™. I didn’t want to create another long theoretical course. I
              wanted to create something you could open when a case is in front of you and immediately know:
            </p>
          </div>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-37" data-mp="2g3nqt9hy2eu2">
            {authorQuotes.map(q => <li key={q} className="rounded-xl bg-brand-900 px-4 py-3 text-[16px] font-semibold text-white" data-id="element-38" data-mp="2l0mizmi1sbpm">
                “{q}”
              </li>)}
          </ul>
          <p className="mt-6 text-[17px] leading-relaxed text-brand-100" data-id="element-39" data-mp="qn4rxpifowpu">
            My goal is simple: <strong className="text-white" data-id="element-40" data-mp="j4ndr5zm4tqj">give you a more structured way to review CBCT
            information — one case at a time.</strong>
          </p>
          <p className="mt-4 font-serif text-xl font-bold italic" data-id="element-41" data-mp="ec40yb8r22ms">— Dr. Michael Carter</p>
          <p className="mt-6 text-xs leading-relaxed text-brand-300" data-id="element-42" data-mp="9evjkcvfe2ml">
            The CBCT Decision Map™ is designed as an educational decision-support and reference resource. It does not
            replace professional judgment, appropriate training, specialist consultation, or applicable standards of
            care.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-5xl px-4 sm:px-6" data-id="element-43" data-mp="s423g37yh09z">
        <CtaButton label="I want Dr. Carter’s review system" data-id="element-44" data-mp="s6obe3yrdhsq" />
      </div>
    </section>;
}